import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "BuildingInsights"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 9H1.5C1.50455 4.85975 4.85975 1.50455 9 1.5V3C5.688 3.00413 3.00413 5.688 3 9ZM5.25 9H6.75C6.75124 7.75787 7.75787 6.75124 9 6.75V5.25C6.92996 5.25248 5.25248 6.92996 5.25 9ZM13.5 6H15V7.5H13.5V6ZM18 6H19.5V7.5H18V6ZM15 10.5H13.5V12H15V10.5ZM18 10.5H19.5V12H18V10.5ZM15 15H13.5V16.5H15V15ZM18 15H19.5V16.5H18V15ZM12 1.5H21C21.8281 1.50083 22.4992 2.17192 22.5 3V22.5H1.5V12C1.50083 11.1719 2.17192 10.5008 3 10.5H10.5V3C10.5008 2.17192 11.1719 1.50083 12 1.5ZM6.75 21V15.75H9.75V21H6.75ZM11.25 21H21V3H12V12H3V21H5.25V15C5.25 14.5858 5.58579 14.25 6 14.25H10.5C10.9142 14.25 11.25 14.5858 11.25 15V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/BuildingInsights.vue"]]);
